module.exports = __webpack_public_path__ + "img/logo_fondazione.c15d1c09.svg";